import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { DashboardLayout } from "./Dashboard";

const WHEREBY_EMBED_SRC = "https://cdn.srv.whereby.com/embed/v2-embed.js";

function loadWherebyEmbed() {
  if (document.querySelector(`script[src="${WHEREBY_EMBED_SRC}"]`)) return;
  const script = document.createElement("script");
  script.type = "module";
  script.src = WHEREBY_EMBED_SRC;
  document.head.appendChild(script);
}

type TelehealthRoomState = {
  room?: string;
  displayName?: string;
};

export default function TelehealthRoom() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state ?? {}) as TelehealthRoomState;
  const room = String(state.room ?? "").trim();
  const displayName = String(state.displayName ?? "").trim();

  useEffect(() => {
    loadWherebyEmbed();
  }, []);

  return (
    <DashboardLayout activePage="/patients">
      <div className="flex h-[calc(100vh-6rem)] min-h-[32rem] flex-col gap-3">
        <div>
          <Button type="button" variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
        </div>
        {room ? (
          <whereby-embed
            room={room}
            displayName={displayName || undefined}
            style={{ width: "100%", height: "100%", flex: "1 1 auto", minHeight: 0 }}
          />
        ) : (
          <p className="text-sm text-muted-foreground">This visit does not have a meeting room.</p>
        )}
      </div>
    </DashboardLayout>
  );
}
